import React, { useEffect, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { postRequest } from "@react/helpers/fetch"
import Modal  from "@react/shared/ui/Modal"
import Button from "@react/shared/ui/Button"
import ClientSitePicker from "./ClientSitePicker"

// into a fresh project quote. Client/site selection mirrors the project quotes
// index NewQuoteModal exactly.
const UseTemplateModal = ({ isOpen, onClose, template, clientsAutocompleteUrl, sitesAutocompleteUrl }) => {
  const [client,     setClient]     = useState(null)
  const [site,       setSite]       = useState(null)
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    if (!isOpen) return
    setClient(null)
    setSite(null)
    setSubmitting(false)
  }, [isOpen])

  const canSubmit = Boolean(client && site) && !submitting

  const handleConfirm = () => {
    if (!canSubmit || !template) return
    setSubmitting(true)
    postRequest({
      url:  template.instantiate_url,
      body: { quote: { client_id: client.id, site_id: site.id } },
    })
      .then(response => {
        if (response && response.success) {
          window.location.href = response.redirect_to
          return
        }
        setSubmitting(false)
        flashAlert(response?.errors?.join(", ") || I18n.t("quotes.project_quote_templates.index.network_error"))
      })
      .catch(() => {
        setSubmitting(false)
        flashAlert(I18n.t("quotes.project_quote_templates.index.network_error"))
      })
  }

  return (
    <Modal
      isOpen  = {isOpen}
      onClose = {onClose}
      size    = "md"
      eyebrow = {template?.name}
      title   = {I18n.t("quotes.project_quote_templates.use_modal.title")}
      footer  = {
        <>
          <Button variant="ghost" onClick={onClose}>
            {I18n.t("quotes.project_quote_templates.use_modal.cancel")}
          </Button>
          <Button variant="primary" onClick={handleConfirm} disabled={!canSubmit}>
            <FontAwesomeIcon icon="plus" />
            {I18n.t("quotes.project_quote_templates.use_modal.confirm")}
          </Button>
        </>
      }
    >
      <p className="text-sm text-slate-500">
        {I18n.t("quotes.project_quote_templates.use_modal.subtitle")}
      </p>

      <ClientSitePicker
        client                 = {client}
        site                   = {site}
        onClientChange         = {setClient}
        onSiteChange           = {setSite}
        clientsAutocompleteUrl = {clientsAutocompleteUrl}
        sitesAutocompleteUrl   = {sitesAutocompleteUrl}
      />
    </Modal>
  )
}

export default UseTemplateModal
